'use client'

import { useParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { FaMapMarkerAlt } from 'react-icons/fa'

import '@/styles/components/_branchLinks.scss'

//_INTERFACE
interface BranchLink {
  name: string
  public_path: string
}

interface BranchLinksProps {
  branches: BranchLink[]
  activeBranch: string
}

export default function BranchLinks({ branches, activeBranch }: BranchLinksProps) {
  const [currentActiveBranch, setCurrentActiveBranch] = useState(activeBranch)

  const params = useParams()
  const locale = params.locale as string
  const city = params.city as string

  return (
    <div className='branchs-links-container'>
      {branches.map((branch, index) => {
        const branchUrl = `/${locale}/destination/${city}/${branch.public_path}`

        return (
          <a
            key={index}
            href={branchUrl}
            className={`branch-link ${
              branch.public_path.toLowerCase() === currentActiveBranch ? 'active' : ''
            }`}>
            <FaMapMarkerAlt className='branch-icon' />
            <span className='branch-name'>{branch.name}</span>
          </a>
        )
      })}
    </div>
  )
}
